import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import {
  setLoading,
  saveData,
  setActivePage,
  setDropdownLoading,
  setVMOptions,
  setVMSelectedOptions,
  setButtonLoading
} from './actions';
import parseResponseToOptions from '../../utils/parseResponseToOptions';
import Orders from './component';

class OrdersContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 250,
      offset: 0,
      status: '',
      vmId: ''
    };
  }

  componentDidMount() {
    // fetch all the permissions
    this.props.setLoading(true);
    this.props.setDropdownLoading(true);
    this.props.setActivePage(1);

    this.props.getDataFromAPI(
      `/orders/all?limit=${this.state.limit}&offset=${this.state.offset}`,
      'GET',
      undefined,
      response => {
        this.props.saveData(response);
        this.props.setLoading(false);
      },
      err => {
        this.props.setLoading(false);
        toastr.error('ERROR', err);
        console.log(err);
      }
    );

    // load the VMs
    this.props.getDataFromAPI(
      `/vendingmachines/all`,
      'GET',
      undefined,
      response => {
        this.props.setVMOptions([
          { key: 0, text: 'All', value: 'all' },
          ...parseResponseToOptions(response.list)
        ]);
        this.props.setDropdownLoading(false);
      },
      err => {
        this.props.setDropdownLoading(false);
        toastr.error('ERROR', err);
        console.log(err);
      }
    );
  }

  onDownloadClick = () => {
    this.props.setButtonLoading(true);
    this.props.getDataFromAPI(
      '/orders/download',
      'GET',
      undefined,
      response => {
        this.props.setButtonLoading(false);
        window.open(response.link, '_blank');
      },
      err => {
        this.props.setButtonLoading(false);
        toastr.error('ERROR', err);
        console.log(err);
      }
    );
  };

  onPageChange = (e, { activePage }) => {
    this.props.setActivePage(activePage);
    this.props.setLoading(true);

    let URL = `/orders/all?limit=${this.state.limit}&offset=${this.state.limit * (activePage - 1)}`;
    if (
      this.state.vmId &&
      this.state.vmId !== 'all' &&
      this.state.status &&
      this.state.status !== 'all'
    ) {
      URL += ` &vmId=${this.state.vmId}&status=${this.state.status}`;
    } else if (this.state.vmId && this.state.vmId !== 'all') {
      URL += ` &vmId=${this.state.vmId}`;
    } else if (this.state.status && this.state.status !== 'all') {
      URL += ` &status=${this.state.status}`;
    }

    this.props.getDataFromAPI(
      URL,
      'GET',
      undefined,
      response => {
        this.props.saveData(response);
        this.props.setLoading(false);
      },
      err => {
        this.props.setLoading(false);
        toastr.error('ERROR', err);
        console.log(err);
      }
    );
    this.setState((prevState, props) => {
      return {
        offset: prevState.limit * activePage
      };
    });
  };

  onChangeOfDropdown = (e, { value }) => {
    this.props.setVMSelectedOptions(value);

    this.setState((prevState, props) => {
      return {
        vmId: value
      };
    });

    let URL = `orders/all?limit=${this.state.limit}&offset=${0}`;
    if (
      this.state.vmId &&
      this.state.vmId !== 'all' &&
      this.state.status &&
      this.state.status !== 'all'
    ) {
      URL += ` &vmId=${this.state.vmId}&status=${this.state.status}`;
    } else if (this.state.vmId && this.state.vmId !== 'all') {
      URL += ` &vmId=${this.state.vmId}`;
    } else if (this.state.status && this.state.status !== 'all') {
      URL += ` &status=${this.state.status}`;
    }

    this.props.getDataFromAPI(
      URL,
      'GET',
      undefined,
      response => {
        this.props.saveData(response);
        this.props.setLoading(false);
      },
      err => {
        this.props.setLoading(false);
        toastr.error('ERROR', err);
        console.log(err);
      }
    );
  };

  render() {
    const orderData =
      this.props.orders && this.props.orders.orderData && this.props.orders.orderData.list;
    const loading = this.props.orders && this.props.orders.loading;
    const activePage = this.props.orders && this.props.orders.activePage;
    const totalPages =
      this.props.orders && this.props.orders.orderData && this.props.orders.orderData.total;
    const dropdownLoading = this.props.orders && this.props.orders.vmLoading;
    const dropdownOptions = this.props.orders && this.props.orders.vmOptions;
    const dropdownDefaultSelected = this.props.orders && this.props.orders.vmDefaultSelected;
    const dwnBtnLoading = this.props.orders && this.props.orders.dwnBtnLoading;

    return (
      <Orders
        loading={loading}
        orderData={orderData}
        activePage={activePage}
        totalPages={totalPages / this.state.limit}
        onPageChange={this.onPageChange}
        dropdownLoading={dropdownLoading}
        dropdownOptions={dropdownOptions}
        onChangeOfDropdown={this.onChangeOfDropdown}
        dropdownDefaultSelected={dropdownDefaultSelected}
        dwnBtnLoading={dwnBtnLoading}
        onDownloadClick={this.onDownloadClick}
      />
    );
  }
}

function mapStateToProps({ orders }) {
  return {
    orders
  };
}

export default withRouter(
  connect(mapStateToProps, {
    getDataFromAPI,
    setLoading,
    saveData,
    setActivePage,
    setDropdownLoading,
    setVMOptions,
    setVMSelectedOptions,
    setButtonLoading
  })(OrdersContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/Orders/container.jsx